<template lang="html">
	<div class="ne-modal">
		<div
			class="overlay"
			v-show="showModal"
			@click="handleOverlayClick($event)"
		>
			<div class="row justify-content-end">
				<div
					class="ne-modal-content"
					:class="content_class"
					@click.stop
				>
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		content_class: {
			type: String,
			default: '',
		},
	},
	watch: {
		show() {
			this.showModal = this.show;
		},
		showModal(newVal) {
			this.$emit('update:show', newVal);
			this.$emit('input', newVal);
			if (!newVal) {
				this.$emit('close');
			}
		},
	},
	data() {
		return {
			showModal: this.show,
			isLoading: this.loading,
		};
	},
	methods: {
		handleOverlayClick(event) {
			if (event && event.target && event.target.closest) {
				const inside = event.target.closest('.ne-modal-content');
				if (inside) return;
			}
			this.showModal = false;
		},
		onKeyDown(e) {
			if (e && (e.key === 'Escape' || e.keyCode === 27)) {
				this.showModal = false;
			}
		},
	},
	mounted() {
		window.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyDown);
	},
};
</script>

<style lang="less">
@brand-magenta: #e91e63;
@brand-orange: #ff9800;
@brand-teal: #1db584;
@brand-blue: #2196f3;

@white: #ffffff;
@grey-50: #fafafa;
@grey-100: #f5f5f5;
@grey-200: #eeeeee;
@grey-400: #bdbdbd;
@grey-600: #757575;
@grey-700: #616161;
@grey-800: #424242;
@grey-900: #212121;

@text-primary: #212121;
@text-secondary: #757575;
@text-muted: #9e9e9e;

.ne-modal {
	.overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(33, 33, 33, 0.6);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.ne-modal-content {
		background: @white;
		border-radius: 12px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
		padding: 30px;
		max-width: fit-content;
		max-height: 70vh;
		overflow-y: auto;
		border: 1px solid @grey-200;

		.content-title {
			font-size: 20px;
			font-weight: 600;
			color: @text-primary;
			margin-bottom: 16px;
		}

		.card {
			margin: 20px 0;
			padding: 22px 18px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid @grey-100;
			background: @grey-50;
		}
	}
}

@media (max-width: 768px) {
	.ne-modal {
		.ne-modal-content {
			padding: 20px;
			margin: 16px;
			width: calc(100% - 32px);

			.card {
				padding: 18px 14px;
			}
		}
	}
}
</style>
